import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle } from 'lucide-react';
import { images } from '../mock';

export const WhoWeAre = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-bold text-[#1F3C88] text-center mb-12">
          {t.whoWeAre.title}
        </h1>

        <div className="max-w-4xl mx-auto space-y-12">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {t.whoWeAre.description}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t.whoWeAre.driverDescription}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-12">
            <img
              src={images.taxiCar}
              alt="Professional Taxi Service"
              className="rounded-lg shadow-xl w-full h-64 object-cover"
            />
            <img
              src={images.professionalCab}
              alt="Clean and Modern Vehicles"
              className="rounded-lg shadow-xl w-full h-64 object-cover"
            />
          </div>

          <Card className="border-none shadow-xl bg-gray-50">
            <CardContent className="p-8">
              <h2 className="text-2xl md:text-3xl font-bold text-[#1F3C88] mb-6">
                {t.whoWeAre.whyChooseTitle}
              </h2>
              <ul className="space-y-4">
                {t.whoWeAre.reasons.map((reason, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle className="h-6 w-6 text-[#FBC02D] flex-shrink-0 mt-1" />
                    <span className="text-lg text-gray-700">{reason}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};